<template>
    <div v-loading="loading" element-loading-text="正在导出数据" style="padding: 20px">
        <div style="margin-bottom:20px">
            <el-select placeholder="校区类型" style="width: 120px;margin-right: 10px" v-model="query.campusType">
                <el-option :value="1" label="旧校区"></el-option>
                <el-option :value="2" label="新校区"></el-option>
            </el-select>
            <select-area @areaListId="getAreaListId"/>
            <el-input
                v-model="query.orderId"
                placeholder="旧卡Id"
                style="width: 180px;margin-right: 10px"
                class="mr10"
            ></el-input>
            <el-input
                v-model="query.studentName"
                placeholder="学生姓名"
                style="width: 180px;margin-right: 10px"
                class="mr10"
            ></el-input>
            <el-date-picker
                style="width: 260px;margin-right: 10px"
                v-model="v2"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
            >
            </el-date-picker>
            <el-button
                type="primary"
                icon="Search"
                style="margin-left: 10px"
                @click="handleSearch"
            >搜索
            </el-button>
            
            <el-popconfirm @confirm="exportExcel" title="确定要导出吗？">
                <template #reference>
                <el-button v-permission="['batchTurn:export']" type="primary"  icon="Download"
                >导出
                </el-button
                >
                </template>
            </el-popconfirm>
        </div>
        <el-table style="overflow-x: auto !important;"
              v-loading="tableLoading"
              :data="tableData"
              border
              class="table el-table__cell"
              ref="multipleTable"
              :row-style="{ height: 57 + 'px' }"
              :cell-style="{ padding: 0 + 'px' }"
              height="610px"
              header-cell-class-name="table-header"
              @selection-change="handleSelectionChange"
    >
      <el-table-column
          fixed
          show-overflow-tooltip="true"
          prop="studentName"
          label="学生姓名"
          width="100"
      />
     
      <el-table-column
            width="120"
          show-overflow-tooltip="true"
          align="center"
          label="主卡ID"
          prop="orderId"
        />
      <el-table-column width="120" label="所属城市">
        <template #default="scope">{{ scope.row.cityName }}</template>
      </el-table-column>
      <el-table-column
          width="120"
          show-overflow-tooltip="true"
          label="转卡前校区"
      >
        <template #default="scope">{{ scope.row.oldCampusName }}</template>
      </el-table-column>
      <el-table-column
          width="120"
          show-overflow-tooltip="true"
          label="转卡后校区"
      >
        <template #default="scope"
        >{{ scope.row.newCampusName}}
        </template>
      </el-table-column>
      <el-table-column width="110" label="转卡前金额">
        <template #default="scope">{{
            scope.row.newCardMoney
          }}
        </template>
      </el-table-column>
      <el-table-column width="110" label="转卡后金额">
        <template #default="scope">{{
            scope.row.newCardMoney
          }}
        </template>
      </el-table-column>
      <el-table-column width="110" prop="oldUsedMoney" label="旧卡使用金额">
        <template #default="scope">
          <div>{{ scope.row.oldUsedMoney }}元</div>
        </template>
      </el-table-column>
      <!-- <el-table-column width="110" prop="money" label="转卡总金额">
        <template #default="scope">
          <div>{{ scope.row.totalPayMoney }}元</div>
        </template>
      </el-table-column>
      <el-table-column width="110" label="收款金额">
        <template #default="scope">
          <div v-if="scope.row.tradingList != null">
            <el-popover
                placement="top"
                title="缴费记录"
                :width="260"
                trigger="hover"
            >
              <el-table :data="scope.row.tradingList">
                <el-table-column prop="name" label="缴费名称">
                  <template #default="scope"
                  >{{ scope.row.name != null ? scope.row.name : "" }}
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="收款金额">
                  <template #default="scope"
                  >{{ scope.row.money != null ? scope.row.money : "" }}
                  </template>
                </el-table-column>
              </el-table>
              <template #reference>
                <el-button type="text" style="color: #606266"
                > {{ scope.row.proceedsSum }}元
                </el-button
                >
              </template>
            </el-popover>
          </div>
          <div v-else>{{ scope.row.tradingMoney }}元</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="alterRemark"
            show-overflow-tooltip="true"
            label="备注">
        </el-table-column>
      <el-table-column
          prop="alterDate"
          label="添加时间"
        />
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="query.pageIndex"
                :page-size="query.pageSize"
                :total="pageTotal"
                @current-change="handlePageChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import {loadBatchAlterCard,excelBatchAlterCard} from '@/api/order'
import selectArea from "../../../components/SelectArea";
    export default{ 
        components: {
            selectArea,
        },
        data(){
            return{
                tableLoading:false,
                v2:[],
                loading:false,
                query:{
                    pageIndex:1,
                    pageSize:10,
                    endTime: "",
                    newCampusIds: [],
                    newOrderId: 0,
                    oldCampusIds: [],
                    orderId: null,
                    startTime: "",
                    studentName: ""
                },
                tableData:[],
                pageTotal:0
            }
        },
        created(){
            this.getDataList()
        },
        methods:{
            getDataList(){
                this.tableLoading = true
                loadBatchAlterCard(this.query).then(res=>{             
                    if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pageTotal = res.data.total;
                    this.tableLoading = false
                    } else {
                    this.$message.error("获取表格数据失败");
                    this.tableLoading = false
                    }
                })
            },
            exportExcel(){
                excelBatchAlterCard(this.query)
            },
            getAreaListId(val) {
                this.query.areaList = val;
            },
            handleSearch() {
                console.log(this.v2);
                if (this.v2.length >= 2) {
                    this.query.startTime = this.v2[0];
                    this.query.endTime = this.v2[1];
                }
                this.query.pageIndex = 1;
                this.getDataList();
            },
            handlePageChange(val){
                this.query.pageIndex = val;
                this.getDataList();
            },
        }
    }
</script>
<style>

</style>
